import actions from './actions'
import mutations from './mutations'
import defaultState from './defaultState'
import getters from './getters'

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state: defaultState(),
}
